import React, { useEffect } from 'react';
import { useProfile } from './ProfileContext';
import ProfileBasicInfo from '@/components/profile/ProfileBasicInfo';
import ProfileFinancialGoals from '@/components/profile/ProfileFinancialGoals';
import ProfileRiskAssessment from '@/components/profile/ProfileRiskAssessment';
import ProfileCurrentPortfolio from '@/components/profile/ProfileCurrentPortfolio';
import ProfileInvestmentPreferences from '@/components/profile/ProfileInvestmentPreferences';
import ProfileDashboardPreview from '@/components/profile/ProfileDashboardPreview';

// For flush support
type StepContentFlushFn = () => Promise<void>;

const StepContent: React.FC = () => {
  const { currentStep, profileData, updateProfileData, setFlushStepDataFn } = useProfile();

  // Default: no flush by default
  useEffect(() => {
    setFlushStepDataFn(null);
    // Clean up on step change
    return () => setFlushStepDataFn(null);
  }, [currentStep, setFlushStepDataFn]);

  // Pass a "registerFlush" function only to the first step
  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <ProfileBasicInfo 
          data={profileData.basicInfo} 
          updateData={(data) => updateProfileData('basicInfo', data)}
          registerFlush={setFlushStepDataFn}
        />;
      case 2:
        return <ProfileFinancialGoals 
          data={profileData.financialGoals} 
          updateData={(data) => updateProfileData('financialGoals', data)}
        />;
      case 3:
        return <ProfileRiskAssessment 
          data={profileData.riskAssessment} 
          updateData={(data) => updateProfileData('riskAssessment', data)}
        />;
      case 4:
        return <ProfileCurrentPortfolio 
          data={profileData.currentPortfolio} 
          updateData={(data) => updateProfileData('currentPortfolio', data)}
        />;
      case 5:
        return <ProfileInvestmentPreferences 
          data={profileData.investmentPreferences} 
          updateData={(data) => updateProfileData('investmentPreferences', data)}
        />;
      case 6:
        return <ProfileDashboardPreview profileData={profileData} />;
      default:
        return null;
    }
  };

  return renderStepContent();
};

export default StepContent;
